import React from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { compose } from 'redux'

import { useTechTouchSync } from 'hooks/useTechTouch'
import MultiTenantsPage from './pages/MultiTenantsPage'
import EntryPage from './pages/EntryPage'
import EntryTelNumberPage from './pages/EntryTelNumberPage'
import EntryPasscodePage from './pages/EntryPasscodePage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import EntryDriverInfoPage from './pages/EntryDriverInfoPage'
import EntryBookingsPage from './pages/EntryBookingsPage'
import EntryBookingNumberPage from './pages/EntryBookingNumberPage'
import EntryLoadPage from './pages/EntryLoadPage'
import EntryConfirmationPage from './pages/EntryConfirmationPage'
import EntryFinishPage from './pages/EntryFinishPage'
import LoginPage from './pages/LoginPage'

import injectReducer from 'utils/injectReducer'
import injectSaga from 'utils/injectSaga'
import reducers from './reducers'
import { CHECKIN_USER_DATA } from 'utils/loginStorage'
import { decryptFunc } from 'utils/commonFunctions'
import Storage from './Storage'
import saga from './saga'

// /receipt-booking/ 配下のパスから warehouseId / tenantId を抽出する
// 例: '/receipt-booking/entry-tel-number/123/456' → { warehouseId: '123', tenantId: '456' }
// /mtenants/ 等の他パスでは null を返す
function extractIds(path) {
  if (!path || !path.startsWith('/receipt-booking/')) return { warehouseId: null, tenantId: null }
  const nodes = path.split('/').filter(Boolean)
  const last = nodes[nodes.length - 1]
  const secondLast = nodes[nodes.length - 2]
  return {
    warehouseId: /^\d+$/.test(secondLast) ? secondLast : null,
    tenantId: /^\d+$/.test(last) ? last : null,
  }
}

const isSessionLogin = () => {
  const { pathname } = global.location
  const nodes = pathname.split('/')
  const tenantId = nodes[nodes.length - 1]

  if (!pathname.startsWith('/mtenants') && !Number.isNaN(Number(tenantId))) {
    Storage.write('tenantId', tenantId)
  }

  const dataSessionList = decryptFunc(CHECKIN_USER_DATA) || []
  return dataSessionList.some((session) => session.uid === Storage.read('tenantId'))
}

const ReceptionRouting = () => {
  const location = useLocation()

  // ログインページ (/receipt-booking/login) はURLにIDがないため、
  // location.state.referrer（例: /receipt-booking/123/456）からフォールバック取得する
  const fromPath = extractIds(location.pathname)
  const fromReferrer = extractIds(location.state?.referrer)
  const warehouseId = fromPath.warehouseId ?? fromReferrer.warehouseId
  const tenantId = fromPath.tenantId ?? fromReferrer.tenantId

  useTechTouchSync(undefined, warehouseId, tenantId, undefined, undefined)

  return isSessionLogin() ? (
    <Switch>
      <Route path="/mtenants/:multiTenantId" component={MultiTenantsPage} />

      <Route exact path="/receipt-booking/:warehouseId/:tenantId" component={EntryPage} />
      <Route
        path="/receipt-booking/terms-of-service/:warehouseId/:tenantId"
        component={TermsOfServicePage}
      />
      <Route
        path="/receipt-booking/entry-tel-number/:warehouseId/:tenantId"
        component={EntryTelNumberPage}
      />
      <Route
        path="/receipt-booking/entry-passcode/:warehouseId/:tenantId"
        component={EntryPasscodePage}
      />
      <Route
        path="/receipt-booking/entry-driver-info/:warehouseId/:tenantId"
        component={EntryDriverInfoPage}
      />
      <Route
        path="/receipt-booking/entry-bookings/:warehouseId/:tenantId"
        component={EntryBookingsPage}
      />
      <Route
        path="/receipt-booking/entry-booking-number/:warehouseId/:tenantId"
        component={EntryBookingNumberPage}
      />
      <Route path="/receipt-booking/entry-load/:warehouseId/:tenantId" component={EntryLoadPage} />
      <Route
        path="/receipt-booking/entry-confirmation/:warehouseId/:tenantId"
        component={EntryConfirmationPage}
      />
      <Route
        path="/receipt-booking/entry-finish/:warehouseId/:tenantId"
        component={EntryFinishPage}
      />
    </Switch>
  ) : (
    <Switch>
      <Route path="/mtenants/:multiTenantId" component={MultiTenantsPage} />
      <Route path="/receipt-booking/login" component={LoginPage} />
      <Redirect
        to={{ pathname: '/receipt-booking/login', state: { referrer: document.location.pathname } }}
      />
    </Switch>
  )
}

const withReducer = injectReducer({ key: 'reception', reducer: reducers })
const withSaga = injectSaga({ key: 'reception', saga })

export default compose(withReducer, withSaga)(ReceptionRouting)
